let adUserId = $('#USER_ID');
let adSurname = $('.address-surname');
let adName = $('.address-name');
let adPatronymic = $('.address-patronymic');
let adBirthday = $('.address-birthday');
let adEmail = $('.address-email');
let adPhone = $('.address-phone');
let adCity = $('.address-city');
let adStreet = $('.address-street');
let adHouse = $('.address-house');
let adBuilding = $('.address-building');
let adRoom = $('.address-room');

$(document).on('click', '#h-table tr', function () {
    let tableTr = $(this)[0];
    
    adUserId.val(tableTr.dataset.id);
    adSurname.val(tableTr.dataset.surname);
    adName.val(tableTr.dataset.name);
    adPatronymic.val(tableTr.dataset.patronymic);
    adBirthday.val(tableTr.dataset.birthday);
    adEmail.val(tableTr.dataset.email);
    adPhone.val(tableTr.dataset.phone);
    adCity.val(tableTr.dataset.city);
    adStreet.val(tableTr.dataset.street);
    adHouse.val(tableTr.dataset.house);
    adBuilding.val(tableTr.dataset.building);
    adRoom.val(tableTr.dataset.room);

    $('#search-result').hide();
});